





































































import { Vue, Prop, Component } from 'vue-property-decorator';
import CondensedProductList from '@/project/product/condensed/CondensedProductList.vue';

import ProductRecommendationsBlock from '@/project/app/blocks/ProductRecommendationsBlock.vue';
import ProductAccessoriesSearchControl, { ProductRelationType } from '@/project/product/product-tile/ProductRelationSearchControl.vue';
import dictionaryService from '@/core/translation/dictionary.service';
import { ProductDetailsViewModel } from '@/types/apiServerContract';
import Tabs from '@/core/ui-components/tabs/Tabs.vue';
import Tab from '@/core/ui-components/tabs/Tab.vue';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import gtmService from '@/project/tracking/gtm/GTM.service';

@Component({
    components: { Tabs, Tab, SpinnerOverlay, CondensedProductList, ProductRecommendationsBlock, ProductAccessoriesSearchControl }
})
export default class ProductDetailsRelations extends Vue {
    @Prop({ required: true }) product!: ProductDetailsViewModel;

    private loaded: boolean = false;
    private activeTab: string = '';

    private getMessage(msgOrLabel: string): string {
        if (dictionaryService.exists(msgOrLabel)) {
            return dictionaryService.get(msgOrLabel);
        }
        return msgOrLabel;
    }

    get labelAccessoriesText(): string | null {
        const bodyTextKey = 'Product.Relations.ProductAccessoriesRecommended.BodyText';
        return dictionaryService.exists(bodyTextKey) ? dictionaryService.get(bodyTextKey) : null;
    }

    private handleRelationLoaded(relationType: string) {
        this.loaded = true;
    }

    private tabsChanged(tabName: string) {
        this.activeTab = tabName;
        gtmService.trackProductDetailsTabChange(tabName);
    }

    private tabsInit(tabName) {
        this.activeTab = tabName;
    }

    get ProductRelationType() {
        return ProductRelationType;
    }
}
